<template lang="pug">
    #modal-tecnico
        span.subtitle-modal-tecnico Processo selecionado
        .processo(v-if='processos?.length > 0')
            span.processo-item(v-for='processo in processos' :key='processo.codigoImovel') {{ processo.codigoImovel }}
        .modal-tecnico-content(:class='{ "--loading" : isLoading }')
            select-filter-component(
                :list='tecnicos'
                label='nomeRazaoSocial'
                fieldLabel='Selecione o técnico que deseja vincular:'
                placeholder='Selecione o técnico que deseja vincular'
                :filterable='true'
                @change='selecionarTecnico'
            )
            div.chips-container
                chip-component(
                    v-for="(tecnicoVinculado, index) in tecnicosVinculados"
                    :key="tecnicoVinculado.id"
                    :label="tecnicoVinculado.nomeRazaoSocial"
                    border-radius="5px"
                    icon="mdi-close"
                    @iconAction="removeTecnico(index)"
                )

            text-area-input-component.input-despacho(
                v-model='vinculacaoTecnico.despacho',
                label='Despacho*:',
                placeholder=''
        )
        .modal-footer(style="display: flex; justify-content: space-between")
            button-component(
                label='Cancelar',
                icon='mdi-close',
                backgroundColor='var(--primary-gray)',
                color="var(--primary-light-smoke)"
                @click.native="cancelar"
            )
            button-component(
                label='Vincular',
                icon='mdi-link-variant',
                :disabled='isLoading',
                @click.native="vincularTecnico()"
            )
    
    </template>
    
    <script>
    import {
        vincular,
    } from '@/services/processo.service';
    import {
        listarTecnicosDisponiveis
    } from '@/services/usuario.service'
    
    export default {
    
        name: 'ModalVinculacaoTecnico',
    
        props: {
            processo: {
                type: Object,
                required: false
            },
            processos: {
                type: Array,
                required: false,
                default: () => []
            }
        },
    
        data() {
            return {
    
                vinculacaoTecnico: {},
    
                tecnicos: [],

                tecnicosVinculados: [],
    
                isLoading: false,
    
            }
        },
    
        async mounted() {
            this.isLoading = true;
            this.tecnicos = await listarTecnicosDisponiveis();
            this.tecnicos.sort((a, b) => a.nomeRazaoSocial.localeCompare(b.nomeRazaoSocial, 'pt-BR'));
            this.isLoading = false;
        },
    
        methods: {
    
            async vincularTecnico() {
                if (
                    this.processos && this.processos.length > 0 &&
                    this.tecnicosVinculados && this.tecnicosVinculados.length > 0 &&
                    this.vinculacaoTecnico.despacho
                ) {

                    const mensagensErro = [];
                    const mensagensSucesso = [];

                    try {
                        for (const processo of this.processos) {
                            for (const tecnico of this.tecnicosVinculados) {
                                try {
                                    await vincular(processo.id, {
                                        idUsuarioTecnico: tecnico.id,
                                        despacho: this.vinculacaoTecnico.despacho,
                                    });
                                    mensagensSucesso.push(`${tecnico.nomeRazaoSocial} vinculado ao processo do imovel ${processo.codigoImovel}`);
                                } catch (error) {
                                    mensagensErro.push(`Erro ao vincular técnico ${tecnico.id} ao processo ${processo.id}: ${error.message || error}`);
                                }
                            }
                        }

                        this.imprimirMensagensSucesso(mensagensSucesso);
                        this.imprimirMensagensErro(mensagensErro);

                    } catch (err) {
                        this.$toast({
                            showClose: true,
                            message: 'Erro inesperado ao vincular técnicos!',
                            type: 'error',
                        });
                    }
                    this.atualizarGrid();
                    this.cancelar()
                } else {
                    alert('Dados preenchidos incorretamente!');
                }
            },

            imprimirMensagensSucesso(mensagensSucesso) {
                if (mensagensSucesso.length) {
                    const mensagemSucesso = mensagensSucesso.join('<br/><br/>');
                    this.$toast({
                        showClose: true,
                        message: `Técnicos vinculados com sucesso!<br/><br/>${mensagemSucesso}`,
                        type: 'success',
                        dangerouslyUseHTMLString: true,
                        duration: 0
                    });
                } 
            },

            imprimirMensagensErro(mensagensErro) {
                if (mensagensErro.length) {
                    const mensagemErro = mensagensErro.join('<br/><br/>');
                    this.$toast({
                        showClose: true,
                        message: `Falha ao vincular alguns técnicos:<br/><br/>${mensagemErro}`,
                        type: 'error',
                        dangerouslyUseHTMLString: true,
                        duration: 0
                    });
                }
            },
    
            cancelar() {
                this.$emit('cancelar', true);
            },

            atualizarGrid() {
                this.$emit('atualizarGrid', true);
            },
            
            selecionarTecnico(idTecnico) {
                if (idTecnico != '' && !this.tecnicosVinculados.some(tecnico => tecnico.id === idTecnico)) {
                    this.tecnicosVinculados.push(this.tecnicos.find(tecnico => tecnico.id === idTecnico));
                }
            },

            removeTecnico(index) {
                this.tecnicosVinculados.splice(index, 1);
            },

        }
    
    }
    </script>
    
    <style>
    .modal-tecnico {
        width: 300px;
        color: var(--primary-black);
    }
    
    .subtitle-modal-tecnico {
        font-weight: 600;
        margin-bottom: 15px;
    }
    
    .processo {
        margin: 5px 0px 20px 0px;
    }

    .processo-item {
        display: block;
    }
    
    .modal-tecnico .--loading {
        /* position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0; */
        background-color: var(--primary-smoke);
        background-image: url('../../../assets/loading.gif');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 50px 50px;
        content: '';
    }
    
    .input-despacho {
        margin: 15px 0px;
    }

    .chips-container {
        display: flex;
        flex-wrap: wrap;
        gap: 5px; 
        padding-top: 5px;
        max-width: 400px;
    }
    </style>
    